import {
    IConfigSchema,
    TYPE_COLUMN_TOTAL,
    TYPE_COLUMN_HIGH_CHART
} from '@/containers/E4ImpactProjects/resources/config-schema';
import {averageNumberOfJobsCreatedPerEntrepreneurTotalCalculation} from './total-calculations/average-number-of-jobs-created-per-entrepreneur-total-calculation';
import {jobCreatedTotalCalculation} from './total-calculations/job-created-total-calculation';
import {newJobsByGenderChartCalculation} from './chart-calculations/new-jobs-by-gender-chart-calculation';
import {newJobsByTermOfContractsChartCalculation} from './chart-calculations/new-jobs-by-term-of-contracts-chart-calculation';
import {newJobsByTypeOfContractsChartCalculation} from './chart-calculations/new-jobs-by-type-of-contracts-chart-calculation';
import {numberOfHighSkillJobsCreatedPerEntrepreneurByGenderChartCalculation} from './chart-calculations/number-of-high-skill-jobs-created-per-entrepreneur-by-gender-chart-calculation';
import {numberOfHighSkillJobsCreatedPerEntrepreneurByGenderTotalCalculation} from './total-calculations/number-of-high-skill-jobs-created-per-entrepreneur-by-gender-total-calculation';
import {newSeasonalContractsTotalCalculation} from './total-calculations/new-seasonal-contracts-total-calculation';
import {newSeasonalContractsPerEntrepreneurTotalCalculation} from './total-calculations/new-seasonal-contracts-per-entrepreneur-total-calculation';
import {e4ImpactContributionToResultsChartCalculation} from './chart-calculations/e4impact-contribution-to-results-chart-calculation';

export const configSchema = (props: any): IConfigSchema => ([
    {
        titleSection: {
            title: 'Job creation',
        },
        rows: [
            {
                columns: [
                    {
                        title: 'Average number of jobs created per entrepreneur',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: averageNumberOfJobsCreatedPerEntrepreneurTotalCalculation(props),
                    },
                    {
                        title: 'KPI: Total job created',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: jobCreatedTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: New jobs by gender',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: newJobsByGenderChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: New jobs by term of contracts',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: newJobsByTermOfContractsChartCalculation(props),
                    },
                    {
                        title: 'KPI: New jobs by type of contracts',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: newJobsByTypeOfContractsChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: Number of high-skill jobs created per entrepreneur by gender',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: numberOfHighSkillJobsCreatedPerEntrepreneurByGenderTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: '',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: numberOfHighSkillJobsCreatedPerEntrepreneurByGenderChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: New seasonal contracts',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: newSeasonalContractsTotalCalculation(props),
                    },
                    {
                        title: 'KPI: New seasonal contracts per entrepreneur',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: newSeasonalContractsPerEntrepreneurTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: E4Impact contribution to results',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: e4ImpactContributionToResultsChartCalculation(props),
                    },
                ]
            },
        ]
    },
]);